// extracted by mini-css-extract-plugin
export var footer = "_o7-5";
export var fulfillmentInput = "_o7-0";
export var shipDateInput = "_o7-1";
export var shipmentModal = "_o7-2";
export var shipmentModalContent = "_o7-3";
export var tableContainer = "_o7-4";